import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { CPAP7Tips } from './pages/CPAP-7-Tips';
import { CPAPPillowsInvestigation } from './pages/CPAP-Pillows-Investigation';
import { EMFEVCabinPressure } from './pages/EMF-EV-Cabin-Pressure';
import { EVHiddenEnemy } from './pages/EV-Hidden-Enemy';
import { EMFInvestigation } from './pages/EMF-Investigation';
export function AppRouter() {
  return <BrowserRouter data-id="element-18">
      <Routes data-id="element-19">
        <Route path="/" element={<App data-id="element-21" />} data-id="element-20" />
        <Route path="/cpap-7-tips" element={<CPAP7Tips data-id="element-23" />} data-id="element-22" />
        <Route path="/cpap-pillows-investigation" element={<CPAPPillowsInvestigation data-id="element-25" />} data-id="element-24" />
        <Route path="/emf-ev-cabin-pressure" element={<EMFEVCabinPressure data-id="element-27" />} data-id="element-26" />
        <Route path="/ev-hidden-enemy" element={<EVHiddenEnemy data-id="element-29" />} data-id="element-28" />
        <Route path="/emf-investigation" element={<EMFInvestigation data-id="element-31" />} data-id="element-30" />
      </Routes>
    </BrowserRouter>;
}